/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionSettleDetailRespVo } from './CommissionSettleDetailRespVo';
import {
    CommissionSettleDetailRespVoFromJSON,
    CommissionSettleDetailRespVoFromJSONTyped,
    CommissionSettleDetailRespVoToJSON,
    CommissionSettleDetailRespVoToJSONTyped,
} from './CommissionSettleDetailRespVo';

/**
 * 
 * @export
 * @interface ResponseCommissionSettleDetailRespVo
 */
export interface ResponseCommissionSettleDetailRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseCommissionSettleDetailRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseCommissionSettleDetailRespVo
     */
    message?: string;
    /**
     * 
     * @type {CommissionSettleDetailRespVo}
     * @memberof ResponseCommissionSettleDetailRespVo
     */
    data?: CommissionSettleDetailRespVo;
}

/**
 * Check if a given object implements the ResponseCommissionSettleDetailRespVo interface.
 */
export function instanceOfResponseCommissionSettleDetailRespVo(value: object): value is ResponseCommissionSettleDetailRespVo {
    return true;
}

export function ResponseCommissionSettleDetailRespVoFromJSON(json: any): ResponseCommissionSettleDetailRespVo {
    return ResponseCommissionSettleDetailRespVoFromJSONTyped(json, false);
}

export function ResponseCommissionSettleDetailRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCommissionSettleDetailRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : CommissionSettleDetailRespVoFromJSON(json['data']),
    };
}

export function ResponseCommissionSettleDetailRespVoToJSON(json: any): ResponseCommissionSettleDetailRespVo {
    return ResponseCommissionSettleDetailRespVoToJSONTyped(json, false);
}

export function ResponseCommissionSettleDetailRespVoToJSONTyped(value?: ResponseCommissionSettleDetailRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': CommissionSettleDetailRespVoToJSON(value['data']),
    };
}

